const conditions = () => {
  return [{ assetClass: { $ne: '' } }, { assetClass: ['object.asset-class.options.logistik-industrie', 'object.asset-class.options.handel-retail', 'object.asset-class.options.office'] }]
}

export default conditions
